module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    attrs: {
      "header": "Pokrzyk-Plaid"
    }
  }, [_c('div', {
    attrs: {
      "id": "auth-card"
    }
  }, [_c('div', [_vm._v("Use your google account to sign in.")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "http://google.com"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.onClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "button_logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "button_text"
  }, [_vm._v("Sign in with Google")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7ea8e12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignIn.vue
// module id = 224
// module chunks = 1